// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UAMachineryLifetimeVariable
 */
export interface UAMachineryLifetimeVariable {
    /**
     * 
     */
    displayName: string;
    /**
     * 
     */
    engineeringUnits: string;
    /**
     * 
     */
    startValue: number;
    /**
     * 
     */
    limitValue: number;
    /**
     * 
     */
    indication?: string;
    /**
     * 
     */
    warningValues?: Array<number>;
}

/**
 * Check if a given object implements the UAMachineryLifetimeVariable interface.
 */
export function instanceOfUAMachineryLifetimeVariable(value: object): value is UAMachineryLifetimeVariable {
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('engineeringUnits' in value) || value['engineeringUnits'] === undefined) return false;
    if (!('startValue' in value) || value['startValue'] === undefined) return false;
    if (!('limitValue' in value) || value['limitValue'] === undefined) return false;
    return true;
}

export function UAMachineryLifetimeVariableFromJSON(json: any): UAMachineryLifetimeVariable {
    return UAMachineryLifetimeVariableFromJSONTyped(json, false);
}

export function UAMachineryLifetimeVariableFromJSONTyped(json: any, ignoreDiscriminator: boolean): UAMachineryLifetimeVariable {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['displayName'],
        'engineeringUnits': json['engineeringUnits'],
        'startValue': json['startValue'],
        'limitValue': json['limitValue'],
        'indication': json['indication'] == null ? undefined : json['indication'],
        'warningValues': json['warningValues'] == null ? undefined : json['warningValues'],
    };
}

export function UAMachineryLifetimeVariableToJSON(json: any): UAMachineryLifetimeVariable {
    return UAMachineryLifetimeVariableToJSONTyped(json, false);
}

export function UAMachineryLifetimeVariableToJSONTyped(value?: UAMachineryLifetimeVariable | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayName': value['displayName'],
        'engineeringUnits': value['engineeringUnits'],
        'startValue': value['startValue'],
        'limitValue': value['limitValue'],
        'indication': value['indication'],
        'warningValues': value['warningValues'],
    };
}

